<template>
  <div class="home-content-page-v">
    <content-title title="油库管理" :actions="tableAction" @clickMenu="clickTitleMenu"></content-title>
    <div class="output-content" v-loading="loading">
      <mii-base-table :datas="oilDepotList" :table_actions="table_actions" :table_style="2" :ths="ths" @clickTdBtn="clickTdBtn"></mii-base-table>
    </div>
    <el-dialog title="新增油库" :visible.sync="showAdd">
      <div class="case-form">
        <div class="one-input">
          <span>油库代码</span>
          <el-input v-model="newDepot['油库代码']" :disabled="!isNew" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>油库名称</span>
          <el-input v-model="newDepot['油库名称']" size="small" placeholder="请输入"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">取 消</el-button>
        <el-button type="primary" @click="saveDepot">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showDel" size="tiny">
      <span>你确定删除该油库吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDel = false">取 消</el-button>
        <el-button type="primary" @click="delDepot">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable from '@/components_bit/MiiBaseTable'
import {
  depot
} from '@/api/oli_api'
import {
  mapCp
} from '@/cllib'
export default {
  components: {
    ContentTitle,
    MiiBaseTable
  },
  data () {
    return {
      newDepot: {
        '油库名称': '',
        '油库地址': ''
      },
      isNew: false,
      loading: true,
      showDel: false,
      showAdd: false,
      table_actions: [{
        label: '编辑',
        key: 'edit'
      },
      {
        label: '删除',
        key: 'del'
      }],
      tableAction: [{
        key: 'add',
        icon: 'icon-addfriend'
      }],
      oilDepotList: [],
      ths: [{
        key: '油库代码',
        label: '油库代码'
      },
      {
        key: '油库名称',
        label: '油库名称'
      }]
    }
  },
  created () {
    this.loadDepot()
  },
  methods: {
    loadDepot () {
      this.loading = true
      depot({data: {}, action: 'get_depot'}).then((data) => {
        this.oilDepotList = data
        this.loading = false
      })
    },
    clickTitleMenu (key) {
      if (key === 'add') {
        this.newDepot = {
          '油库代码': '',
          '油库名称': ''
        }
        this.isNew = true
        this.showAdd = true
      }
    },
    clickTdBtn (dataMap) {
      this.newDepot = mapCp(dataMap.data)
      if (dataMap.key === 'del') {
        this.showDel = true
      } else if (dataMap.key === 'edit') {
        this.isNew = false
        this.showAdd = true
      }
    },
    saveDepot () {
      if (!this.newDepot['油库代码']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '油库代码必填',
          message: '请输入油库代码'
        })
        return
      }
      let parm = {
        action: this.isNew ? 'add_depot' : 'edit_depot',
        data: this.newDepot
      }
      depot(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: this.isNew ? '油库新增完成' : '油库修改完成'
          })
          this.showAdd = false
          this.loadDepot()
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: this.isNew ? '新增油库失败' : '修改油库失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: this.isNew ? '新增油库失败' : '修改油库失败'
        })
      })
    },
    delDepot () {
      let parm = {
        action: 'del_depot',
        data: {'油库代码': this.newDepot['油库代码']}
      }
      depot(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '油库删除成功'
          })
          this.loadDepot()
          this.showDel = false
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '油库删除失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '油库删除失败'
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.output-btn {
  color:#fff;
  background-color: @bak-color-2;
  padding: 0.5em 1.5em;
  text-align: center;
  border-radius: 0.3em;
  letter-spacing: 0.1em;
}
.output-content {
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  background-color: #fff;
}
.case-form {
  display: flex;
  flex-wrap: wrap;
}
.one-input {
  display: flex;
  justify-content: space-between;
  width: 46%;
  margin: 1rem 2%;
  span {
    width: 9rem;
    font-size: 0.9rem;
  }
}
.checkbox-label {
  .output-btn {
    margin-left: 3em;
  }
}
.btm-btn {
  margin: 1em 0 0 2em;
}
.m-line {
  width: 2px;
  height: 15em;
  background-color: #ccc;
  margin: 1.5em 2.2em 0 0;
}
.output-content-1 {
  flex: 1;
  margin: 1em 2.5em 7em;
  display: flex;

}
.checkbox-content {
  display: flex;
  flex-direction: column;
  span {
    line-height: 1;
    font-size: 1.13em;
    padding-bottom: 0.5em;
    color: @bak-color-2;
  }
}
.checkbox-one {
  display: flex;
  align-items: center;
  height: 3.4em;
  font-size: 1em;
  color:@bak-color-1;
  img {
    padding-right: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// oil_depot.vue?23dc1896